import React, { useEffect, useState } from 'react';
import {
    Grid,
    Box,
    Typography,
    Paper,
    Button
} from '@mui/material';
import {
    AttachMoney,
    AccountBalance,
    MoneyOff,
    KeyboardArrowUp
} from '@mui/icons-material';
import Monthlyincome from '../Incomeandexpenses/Monthlyincome';
import Anualincome from '../Incomeandexpenses/Anualincome';
import Expenses from '../Incomeandexpenses/Expenses';
import Damages from '../Incomeandexpenses/Returns';
import Chart3 from '../Chart/Chart3';
import Stock from '../Home/Stock';
import Invoice from '../Popupdialogbox/Invoice';
import axios from 'axios';
import { styled, keyframes } from '@mui/system';
import Bank from '../Incomeandexpenses/BankBalance';
import Profit from '../Incomeandexpenses/Profit';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import PeopleIcons from '@mui/icons-material/PersonAdd';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import Return from '../Popupdialogbox/Return';
import Inventory from '../Popupdialogbox/inventory';
import Expenses2 from '../Popupdialogbox/Expenses';
import ScrollToTopButton from '../Button/ScrollToTopButton';
import HomeIcon from '@mui/icons-material/Home';
import Barchart from '../Admin/Barchart';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Link as RouterLink } from 'react-router-dom';
import { Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Chart from './Charts/invoicechart';
import ProfitLoss from './Charts/profitandlosschart';
import BarChart2 from './barchart';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from 'recharts';
import Overview from './overview';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SubscriptionExpiryDialog from "../Reminder/SubscriptionExpiryDialog";
import SubscriptionExpiryDialog2 from "../Reminder/SubscriptionExpireDialog2";
import SubscriptionUpdateDialog from "../Reminder/PlanUpgrade";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import TransactionHistory from './TransactionHistory';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import subscriptionChecker from '../Auth2/subscriptionChecker';

const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: `${slideInFromLeft} 0.5s ease-out`,
}));

const fadeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5 } }
};

const Card = ({ title, value, icon: Icon, color, month, orders, showViewButton = true, link, chart }) => {
    return (
        <Box
            elevation={2}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                p: 2,
                bgcolor: 'white',
                border: '1px solid #EDF2F7',
                borderRadius: '16px',
                mx:1,
                mt: 1,
                height: '100px',
                width: {xs:'85%',sm:'90%'}
            }}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="body2" color={color} fontWeight="bold" textTransform="uppercase" mb={1}>
                    {title}
                </Typography>
                <Icon fontSize="large" style={{ color: 'gray', marginLeft: 8 }} />
            </Box>
            <Box>
                <Typography variant="h5" fontWeight="bold" color='#2D3748' >
                    {value}
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography color="text.primary" sx={{ mt: 1, fontSize: '13px', color: '#6d7081' }}>
                        {month}
                    </Typography>
                    {showViewButton && (
                        <Typography
                            component={RouterLink}
                            to={link}
                            sx={{
                                mt: 1,
                                fontSize: '14px',
                                textDecoration: 'none',
                                color: 'primary.main',
                                display: 'inline-flex', // Ensures text and icon align
                                alignItems: 'center',   // Vertical alignment
                                gap: '4px',             // Optional: spacing between text and icon
                                '&:hover': {
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            <span>view report</span>
                            <ArrowOutwardIcon sx={{ fontSize: '16px' }} />
                        </Typography>
                    )}
                </Box>
            </Box>
        </Box>
    );
};


const Home = ({ token, setToken }) => {
    const [user, setUser] = useState({});
    const [userPayments, setUserPayments] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [monthlyTotal, setMonthlyTotal] = useState(0);
    const [annualTotal, setAnnualTotal] = useState(0);
    const [totalExpenses, setTotalExpenses] = useState(0);
    const [totalDamages, setTotalDamages] = useState(0);
    const [totalBanks, setTotalBanks] = useState(0);
    const [totalProfits, setTotalProfits] = useState(0);
    const [users, setUsers] = useState([]);
    const [userCount, setUserCount] = useState(0);
    const [activeUserCount, setActiveUserCount] = useState(0);
    const navigate = useNavigate();
    const [userSubscription, setUserSubscription] = useState(null);
    const [expireuserSubscription, setExpireUserSubscription] = useState(null);


    const handleMonthlyTotalChange = (amount) => {
        setMonthlyTotal(amount);
    };

    const handleAnnualTotalChange = (amount) => {
        setAnnualTotal(amount);
    };


    const handleTotalExpensesChange = (amount) => {
        setTotalExpenses(amount);
    };

    const handleTotalDamagesChange = (amount) => {
        setTotalDamages(amount);
    };


    const handleTotalBanksChange = (amount) => {
        setTotalBanks(amount);
    }

    const handleTotalProfitsChange = (amount) => {
        setTotalProfits(amount);
    }


    const handleTotalAmountChange = (data) => {
        {/**console.log('Total amount data:', data);*/ }
    };


    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/"); // Redirect if no token
                return;
            }

            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/"); // Redirect on 401 error
                }
            }
        };

        fetchProfile();
    }, []);

    const [greeting, setGreeting] = useState('');
    const [showHello, setShowHello] = useState(false);

    useEffect(() => {
        const currentHour = new Date().getHours();

        if (currentHour < 12) {
            setGreeting('Good Morning');
        } else if (currentHour < 18) {
            setGreeting('Good Afternoon');
        } else {
            setGreeting('Good Evening');
        }

        const greetingTimer = setTimeout(() => {
            setGreeting('');
            setShowHello(true);
        }, 10000);

        return () => clearTimeout(greetingTimer);
    }, []);

    const calculateProfit = (annualTotal, totalExpenses, totalDamages) => {
        const total = parseFloat(annualTotal.toFixed(2)) - parseFloat(totalExpenses.toFixed(2)) - parseFloat(totalDamages.toFixed(2));

        return `LKR. ${total.toFixed(2)}`;
    };

    useEffect(() => {
        axios
            .get("https://admin.bizstor.lk/public/api/users")
            .then((response) => {
                setUsers(response.data);
                setUserCount(response.data.length - 1);
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get("https://admin.bizstor.lk/public/api/users")
            .then((response) => {
                const allUsers = response.data;
                setUsers(allUsers);
                const activeUsers = allUsers.filter(user => user.status === 'active');
                setActiveUserCount(activeUsers.length - 1);
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get("https://admin.bizstor.lk/public/api/get-user-payment")
            .then((response) => {
                if (Array.isArray(response.data.userpayment)) {
                    const payments = response.data.userpayment;
                    setUserPayments(payments);

                    const totalAmount = payments.reduce((total, payment) => {
                        return total + Number(payment.amount);
                    }, 0);

                    setTotalAmount(totalAmount);
                } else {
                    console.error("Expected an array for userPayments");
                }
            })
            .catch((error) => {
                console.error("Error fetching user payments:", error);
            })
            .finally(() => {
            });
    }, []);

    function getCurrentMonth(format = 'long') {
        const date = new Date();

        if (format === 'long') {
            // Return the full month name
            return date.toLocaleString('default', { month: 'long' });
        } else if (format === 'short') {
            // Return the short month name
            return date.toLocaleString('default', { month: 'short' });
        } else if (format === 'number') {
            // Return the month as a number (1-12)
            return date.getMonth() + 1; // getMonth() is zero-based
        } else {
            throw new Error("Invalid format. Use 'long', 'short', or 'number'.");
        }
    }

    const [showGreeting, setShowGreeting] = useState(true);

    useEffect(() => {
        if (greeting) {
            setShowGreeting(true);
            const timer = setTimeout(() => setShowGreeting(false), 3000); // Hide after 3 sec
            return () => clearTimeout(timer);
        }
    }, [greeting]);

    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/get-subscription");

                const matchedSub = response.data.subscription
                    .filter(sub => sub.email === user.email && sub.status === "active")
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

                setUserSubscription(matchedSub || null);
            } catch (error) {
                console.error("Failed to fetch subscriptions", error);
            }
        };

        if (user.email) {
            fetchSubscriptions();
        }
    }, [user.email]);


    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/get-subscription");

                const matchedSub = response.data.subscription
                    .filter(sub => sub.email === user.email && sub.status === "expire")
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

                setExpireUserSubscription(matchedSub || null);
            } catch (error) {
                console.error("Failed to fetch subscriptions", error);
            }
        };

        if (user.email) {
            fetchSubscriptions();
        }
    }, [user.email]);

    const isFreePlan = userSubscription?.plan === "free";
    const isBasicPlan = userSubscription?.plan === "basic";
    const isPremiumPlan = userSubscription?.plan === "premium";
    const is30DaysFreePlan = userSubscription?.plan === "30 days free";
    const expire = expireuserSubscription?.plan === "free" || expireuserSubscription?.plan === "basic" || expireuserSubscription?.plan === "premium" || expireuserSubscription?.plan === "30 days free";

    useEffect(() => {
        const initChecker = async () => {
            try {
                await subscriptionChecker.initializeChecker();
            } catch (error) {
                console.error('Failed to initialize subscription checker:', error);
                if (error.response?.status === 401) {
                    localStorage.removeItem('token');
                    navigate('/login');
                }
            }
        };

        initChecker();

        return () => {
            subscriptionChecker.stopChecker();
        };
    }, [navigate]);

    return (
        <Box
            sx={{ mt: 10 }}
        >
            {greeting && (
                <AnimatedTypography
                    component="h1"
                    variant="h5"
                    sx={{
                        ml: 3,
                        mt: 3,
                        fontSize: '2rem',
                        color: 'orange',
                        fontWeight: 'bold',
                        letterSpacing: '0.01em',
                    }}
                >
                    {greeting} {user.name} !
                </AnimatedTypography>
            )}

            {showHello && (
                <AnimatedTypography
                    component="h1"
                    sx={{
                        ml: { xs: 2, sm: 3 },
                        mt: { xs: 2, sm: 3 },
                        color: '',
                        letterSpacing: '0.01em',
                        fontSize: { xs: '20px', sm: '24px' },
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                        {/**<Typography
                            component="span"
                            sx={{
                                display: { xs: 'none', sm: 'inline' },
                                fontSize: { xs: '14px', sm: '16px' },
                                fontWeight: 'bold',
                                color: '',
                            }}
                        >
                            Dashboard
                        </Typography>
                        <Typography
                            component="span"
                            sx={{
                                display: { xs: 'none', sm: 'inline' }, // Hidden on xs
                                ml: 1,
                                fontSize: '14px',
                                color: '',
                            }}
                        >
                            |
                        </Typography>*/}
                        <HomeIcon
                            sx={{
                                ml: 1,
                                fontSize: '18px',
                                color: '#6d7081',
                            }}
                        />
                        <Typography
                            component="span"
                            sx={{
                                ml: 0.5,
                                fontSize: '14px',
                                color: '#6d7081',
                            }}
                        >
                            - Dashboard
                        </Typography>
                    </Box>
                </AnimatedTypography>

            )}

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '95%',
                    maxWidth: 'auto',
                    margin: 'auto',
                    //boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                    padding: '10px',
                    borderRadius: '5px',
                    //bgcolor: 'white',
                    marginTop: '30px',
                    position: 'relative',
                    '@media (max-width: 600px)': {
                        marginTop: '10px',
                    },
                    mb: 2
                }}
            >
                <Grid container spacing={2} justifyContent="center">
                    <Monthlyincome onTotalAmountChange={handleMonthlyTotalChange} />
                    <Anualincome onTotalAmountChange={handleAnnualTotalChange} />
                    <Expenses onTotalExpensesChange={handleTotalExpensesChange} />
                    <Damages onTotalDamagesChange={handleTotalDamagesChange} />
                    <Bank onBalanceChange={handleTotalBanksChange} />
                    <Profit onProfitChange={handleTotalProfitsChange} />


                    {/* Earnings Cards */}
                    {user.email !== 'bizstoradmin@gmail.com' && (
                        <Grid item xs={12} md={6}>
                            <Card
                                title="Sales"
                                value={`LKR ${monthlyTotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                                icon={TrendingUpIcon}
                                color="primary.main"
                                month={`All sales in ${getCurrentMonth('long')}`}
                                orders=""
                                //link="/report-invoice"
                                link={expire ? undefined : (isFreePlan || isBasicPlan || isPremiumPlan || is30DaysFreePlan ? "/report-invoice" : undefined)}
                            //chart={<Chart />} 
                            />
                        </Grid>
                    )}
                    {user.email !== 'bizstoradmin@gmail.com' && (
                        <Grid item xs={12} md={6}>
                            <Card
                                title="Profit"
                                value={
                                    <Typography
                                        variant="h5"
                                        fontWeight="bold"
                                        color={totalProfits < 0 ? "#F56666" : "#2D3748"}
                                    >
                                        LKR {(totalProfits || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </Typography>
                                }
                                icon={AttachMoney}
                                color="success.main"
                                month={`Net profit for ${getCurrentMonth('long')}`}
                                orders=""
                                //link={(isBasicPlan || isPremiumPlan) ? "/report-profit-loss" : undefined}
                                link={expire ? undefined : (isBasicPlan || isPremiumPlan || is30DaysFreePlan ? "/report-profit-loss" : undefined)}
                            />

                        </Grid>)}
                    {user.email !== 'bizstoradmin@gmail.com' && (
                        <Grid item xs={12} md={6}>
                            <Card
                                title="Expenses"
                                value={`LKR ${Number(totalExpenses).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                                icon={MoneyOff}
                                color="error.main"
                                month={`Spending for ${getCurrentMonth('long')}`}
                                orders="  "
                                //link={(isBasicPlan || isPremiumPlan) ? "/report-expenses" : undefined}
                                link={expire ? undefined : (isBasicPlan || isPremiumPlan || is30DaysFreePlan ? "/report-expenses" : undefined)}
                            />
                        </Grid>
                    )}

                    {user.email !== 'bizstoradmin@gmail.com' && (
                        <Grid item xs={12} md={6}>
                            <Card
                                title="Bank"
                                value={`LKR ${((annualTotal + totalBanks).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))}`}
                                icon={AccountBalance}
                                color="secondary.main"
                                month="Current Balance"
                                orders=""
                                //showViewButton={true}
                                link={expire ? undefined : (isBasicPlan || isPremiumPlan || is30DaysFreePlan ? "/bank-account-history" : undefined)}
                            />
                        </Grid>)}
                    {user.email === 'bizstoradmin@gmail.com' && (
                        <Grid item xs={12} md={6}>
                            <Card
                                title="All Users"
                                value={userCount}
                                icon={PeopleIcon}
                                color="secondary.main"
                                showViewButton={false}
                            />
                        </Grid>)}
                    {user.email === 'bizstoradmin@gmail.com' && (
                        <Grid item xs={12} md={6}>
                            <Card
                                title="Active Users"
                                value={activeUserCount}
                                icon={PersonIcon}
                                color="success.main"
                                showViewButton={false}
                            />
                        </Grid>)}
                    {user.email === 'bizstoradmin@gmail.com' && (
                        <Grid item xs={12} md={6}>
                            <Card
                                title="Deactivate Users"
                                value={userCount - activeUserCount}
                                icon={PersonIcon}
                                color="error.main"
                                showViewButton={false}
                            />
                        </Grid>)}
                    {user.email === 'bizstoradmin@gmail.com' && (
                        <Grid item xs={12} md={6}>
                            <Card
                                title="Total Payment"
                                value={`LKR. ${totalAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                                icon={AttachMoney}
                                color="primary.main"
                                showViewButton={false}
                            />
                        </Grid>)}
                    {user.email !== 'bizstoradmin@gmail.com' && (
                        <Grid container spacing={2} sx={{ mt: 4 }}>
                            <Grid item xs={12} md={4}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '40%',
                                        p: 1.5,
                                        bgcolor: 'background.paper',
                                        border: '1px solid #EDF2F7',
                                        borderRadius: '16px',
                                        mx:3,
                                        
                                        width:{sm:'90%',xs:'85%'}

                                    }}
                                >
                                    <Typography variant="h5"
                                        sx={{
                                            color: '#2D3748',
                                            fontWeight: 700,
                                            letterSpacing: '0.5px'
                                        }}
                                    >
                                        <b>Shortcut</b>
                                    </Typography>
                                    <Box
                                        alignItems="center"
                                        mt={2}
                                        sx={{
                                            display: "flex",
                                            flexDirection: { sm: 'row', xs: 'row' },
                                            flexWrap: 'wrap',
                                            '@media (max-width: 600px)': {
                                                marginTop: '20px',
                                            },
                                            borderRadius: 1,
                                            gap: 1
                                        }}
                                    >
                                        <Invoice />
                                        <Return />
                                        <Expenses2 />
                                        <Inventory />
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '40%',
                                        bgcolor: 'background.paper',
                                        border: '1px solid #EDF2F7',
                                        borderRadius: '16px',
                                        mx:3,
                                        width:{sm:'90%',xs:'85%'},
                                        mt: 3,
                                        padding: 1.5
                                    }}
                                >
                                    <Overview />
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Box
                                    sx={{
                                        p: 1.5,
                                        bgcolor: 'background.paper',
                                        border: '1px solid #EDF2F7',
                                        borderRadius: '16px',
                                        height: { xs: '95%', sm: '90%' },
                                        mx:3,
                                        width:{sm:'92%',xs:'85%'},

                                    }}
                                >
                                    <Box >
                                        <Chart3 onTotalAmountChange={handleTotalAmountChange} />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>)}
                </Grid>


                {user.email !== 'bizstoradmin@gmail.com' && (
                    <Grid container sx={{ mt: 1 }}>

                        <Grid item xs={12} sm={12} md={12}>
                            <Box
                                sx={{
                                    p: 2,
                                    bgcolor: 'background.paper',
                                    border: '1px solid #EDF2F7',
                                    borderRadius: '16px',
                                    height: 'auto',
                                    margin: 'auto',
                                    width: { sm: '95%', xs: '85%' }

                                }}
                            >
                                <Box mt={2} >
                                    <BarChart2 onTotalAmountChange={handleTotalAmountChange} />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>)}
                {user.email !== 'bizstoradmin@gmail.com' && (
                    <TransactionHistory />
                )}
                {/**<Grid>
                    {user.email !== 'bizstoradmin@gmail.com' && (
                        <Stock />
                    )}
                </Grid>
                <Grid>
                    {user.email === 'bizstoradmin@gmail.com' && (
                        <Barchart />
                    )}
                </Grid>*/}
                <ScrollToTopButton />
            </Box>
            {/**{user.email !== 'bizstoradmin@gmail.com' && (
            <Stock />
            )} */}
            <SubscriptionExpiryDialog />
            <SubscriptionUpdateDialog />
            <SubscriptionExpiryDialog2 />
        </Box>
    );
};

export default Home;
